import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import Select from "react-select";
import Modal from "react-modal";
const SalesTrainingDetailForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 50,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "4%",
      left: "30%",
      borderRadius: "5px",
      maxWidth: "650px",
      maxHeight: "700px",

      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };

  const frmRef = useRef({});

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const [startTime, setStartTime] = useState(getCurrentTime());
  const [endTime, setEndTime] = useState(getCurrentTime());
  const [venue, setVenue] = useState("");
  const [villageName, setVillageName] = useState("");
  // const [subject, setSubject] = useState("");
  const [topic, setTopic] = useState("");
  const [state, setState] = useState("");
  const [lga, setLga] = useState("");
  const [isSubjectOpen, setIsSubjectOpen] = useState(false);

  const [subjectList, setSubjectList] = useState([
    { subjectName: "" },
    { subjectName: "" },
    { subjectName: "" },
    { subjectName: "" },
  ]);

  const handleSubjectChange = (index, field, value) => {
    const updatedSubjects = [...subjectList];
    if (!updatedSubjects[index]) {
      updatedSubjects[index] = { subjectName: "" };
    }
    updatedSubjects[index][field] = value;
    setSubjectList(updatedSubjects);
  };

  const [trainingType, setTrainingType] = useState("");

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Format hours and minutes with leading zeros if necessary
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  const [isObjOpen, setIsObjOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [close, setClose] = useState(false);

  const [selectionUser, setSelectionUser] = useState([]);
  const [selectedUser, setSelectedUser] = useState();

  const [selectionCrop, setSelectionCrop] = useState([]);
  const [selectedCrop, setSelectedCrop] = useState();

  const [isCropDetailEmpty, setIsCropDetailEmpty] = useState(true);
  const [cropDetails, setCropDetails] = useState();

  const [isExecutiveDetailEmpty, setIsExecutiveDetailEmpty] = useState(true);
  const [executiveDetail, setExecutiveDetail] = useState();

  const [trainerDetails, setTrainerDetails] = useState([
    { trainerName: "", OrganisationName: "", trainerContactNo: "" },
    { trainerName: "", OrganisationName: "", trainerContactNo: "" },
    { trainerName: "", OrganisationName: "", trainerContactNo: "" },
    { trainerName: "", OrganisationName: "", trainerContactNo: "" },
    { trainerName: "", OrganisationName: "", trainerContactNo: "" },
  ]);

  const handleInputChange = (index, field, value) => {
    const updatedTrainerDetails = [...trainerDetails];
    if (!updatedTrainerDetails[index]) {
      updatedTrainerDetails[index] = {
        trainerName: "",
        OrganisationName: "",
        trainerContactNo: "",
      };
    }
    updatedTrainerDetails[index][field] = value;
    //console.log(updatedTrainerDetails);
    setTrainerDetails(updatedTrainerDetails);
  };

  const [objectivesList, setObjectivesList] = useState([
    { objectiveName: "" },
    { objectiveName: "" },
    { objectiveName: "" },
    { objectiveName: "" },
    { objectiveName: "" },
  ]);

  const handleObjectivesChange = (index, field, value) => {
    const updatedObjDetails = [...objectivesList];
    if (!updatedObjDetails[index]) {
      updatedObjDetails[index] = {
        objectiveName: "",
      };
    }
    updatedObjDetails[index][field] = value;
    //console.log(updatedObjDetails);
    setObjectivesList(updatedObjDetails);
  };

  const { sendRequest: getUser } = useHttp();

  useEffect(() => {
    getUser(
      {
        url: `/api/employeeByUsecase/?useCase=Agri Promoter&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          //console.log(res.output);

          var UserOption = [{ value: "0", label: "All" }];
          const mappedOptions = res.output.map((x) => ({
            value: x.empId,
            label: x.employeeName,
          }));

          UserOption = UserOption.concat(mappedOptions);

          setSelectionUser(UserOption);
        }
      }
    );
  }, [getUser]);

  const { sendRequest: getcrop } = useHttp();

  useEffect(() => {
    getcrop(
      {
        url: "/api/crops/",
      },

      (res) => {
        if (res) {
          ////console.log("Crop", res);
          setSelectionCrop(
            res.map((x) => ({
              value: x.cropId,
              label: x.cropName,
            }))
          );
        }
      }
    );
  }, [getcrop]);

  useEffect(() => {
    var convertedData = [];
    if (selectedUser && selectedUser.length > 0) {
      if (selectedUser[0].label == "All") {
        const filteruser =
          selectionUser && selectionUser.filter((itm) => itm.value != "0");

        convertedData =
          filteruser &&
          filteruser.map((item) => {
            return { fieldExecutiveId: item.value };
          });
      } else {
        convertedData =
          selectedUser &&
          selectedUser.map((item) => {
            return { fieldExecutiveId: item.value };
          });
      }
    }

    console.log("convertedData", convertedData);
    setExecutiveDetail(convertedData);
    setIsExecutiveDetailEmpty(!convertedData || convertedData.length === 0);
  }, [selectedUser]);

  const handleUserChange = (option) => {
    var userarray = option;
    if (option && option.length > 1) {
      if (
        option[option.length - 1].label == "All" ||
        option[0].label == "All"
      ) {
        const opt = option[option.length - 1];
        option = [opt];
      }
    }

    setSelectedUser(option);
  };

  useEffect(() => {
    const convertedData =
      selectedCrop &&
      selectedCrop.map((item) => {
        return { cropId: item.value.toString(), cropName: item.label };
      });

    setCropDetails(convertedData);
    setIsCropDetailEmpty(!convertedData || convertedData.length === 0);
    //console.log(convertedData);
  }, [selectedCrop]);

  const handleCropChange = (option) => {
    setSelectedCrop(option);
  };

  const { sendRequest: postTrainingDetails } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const cleanedTrainers = trainerDetails.filter(
      (trainer) =>
        trainer.trainerName?.trim() ||
        trainer.OrganisationName?.trim() ||
        trainer.trainerContactNo?.trim()
    );

    const cleanedObjectives = objectivesList.filter((obj) =>
      obj.objectiveName?.trim()
    );

    // 👉 Add validations before preparing `data`
    if (!cleanedObjectives.length) {
      toast.error("Please add at least one objective before submitting.");
      return;
    }

    if (!cleanedTrainers.length) {
      toast.error("Please add at least one trainer before submitting.");
      return;
    }

    if (!cropDetails || !cropDetails.length) {
      toast.error("Please select at least one focused crop before submitting.");
      return;
    }

    if (!executiveDetail || !executiveDetail.length) {
      toast.error("Please select at least one executive before submitting.");
      return;
    }

    const data = {
      date: moment(selectedDate).format("DD/MM/YYYY"),
      venue: venue,
      village: villageName,
      startTime: startTime,
      endTime: endTime,
      focusedCrop: cropDetails,
      subjectsList: subjectList.filter((s) => s.subjectName?.trim()),
      lga: lga,
      state: state,
      executiveDetail: executiveDetail,
      topicOfDiscussion: topic,
      objectivesList: cleanedObjectives,
      trainersList: cleanedTrainers,
      trainingFor: "Sales",
      trainingType: trainingType,
      createdDate: moment(new Date().toISOString()).format(
        "DD/MM/YYYY hh:mm:ss"
      ),
      orgId: parseInt(localStorage.getItem("orgId")),
      status: 1,
      createdBy: parseInt(localStorage.getItem("id")),
    };

    if (props.update) {
      data["trainingDetailId"] = props.update.trainingDetailId;
    }

    postTrainingDetails(
      {
        url: "/api/training/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        toast.success(
          `Training Details ${props.update ? "Updated" : "Added"} Successfully`
        );
        props.addForm(false);
      }
    );
  };

  const { sendRequest: getTrainingDetails } = useHttp();
  useEffect(() => {
    if (props.update) {
      const Id = (props.update && props.update.trainingDetailId) || 0;

      getTrainingDetails(
        {
          url: `/api/training/?orgId=${localStorage.getItem(
            "orgId"
          )}&trainingDetailId=${Id}`,
        },
        (res) => {
          if (res) {
            const data = res;

            setSelectedDate(
              moment(data.date, "DD/MM/YYYY").format("YYYY-MM-DD")
            );
            setStartTime(data.startTime);
            setEndTime(data.endTime);
            setVenue(data.venue);
            setVillageName(data.village);
            setSubjectList(
              (data.subjectsList || []).map((s) => ({
                subjectName: s.subject,
              }))
            );
            setTopic(data.topicOfDiscussion);
            setTrainingType(data.trainingType);
            setState(data.state);
            setLga(data.lga);

            if (data.focusedCrop) {
              setSelectedCrop(
                data.focusedCrop.map((crop) => ({
                  value: crop.cropId,
                  label: crop.cropName,
                }))
              );
            }

            if (data.trainingFieldExecutiveDetail) {
              setSelectedUser(
                data.trainingFieldExecutiveDetail.map((executive) => ({
                  value: executive.fieldExecutiveId,
                  label: executive.employeeName,
                }))
              );
            }

            setObjectivesList(data.objectivesList || []);
            setTrainerDetails(data.trainersList || []);
          }
        }
      );
    }
  }, [props.update]);

  return (
    <>
      {isOpen && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Trainer Details List</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="row">
            <table className="table table-bordered text-center">
              <thead>
                <tr>
                  <th>Sr No</th>
                  <th>Name Of Trainer</th>
                  <th>Name Of Organisation</th>
                  <th>Contact Number</th>
                </tr>
              </thead>
              <tbody>
                {trainerDetails &&
                  trainerDetails.map((trainer, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={trainer.trainerName}
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "trainerName",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={trainer.OrganisationName}
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "OrganisationName",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          value={trainer.trainerContactNo}
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "trainerContactNo",
                              e.target.value
                            )
                          }
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          <div className="text-center">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}

      {isSubjectOpen && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Subject List</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                onClick={() => setIsSubjectOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="row">
            <table className="table table-bordered text-center">
              <thead>
                <tr>
                  <th>Sr No</th>
                  <th>Subject</th>
                </tr>
              </thead>
              <tbody>
                {subjectList &&
                  subjectList.map((subj, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={subj.subjectName}
                          onChange={(e) =>
                            handleSubjectChange(
                              index,
                              "subjectName",
                              e.target.value
                            )
                          }
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          <div className="text-center">
            <button
              type="button"
              className="btn btn-primary mx-2 my-2"
              onClick={() => {
                setIsSubjectOpen(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}

      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Objectives List</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="row">
            <table className="table table-bordered text-center">
              <thead>
                <tr>
                  <th>Sr No</th>
                  <th>Objective</th>
                </tr>
              </thead>
              <tbody>
                {objectivesList &&
                  objectivesList.map((obj, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={obj.objectiveName}
                          onChange={(e) =>
                            handleObjectivesChange(
                              index,
                              "objectiveName",
                              e.target.value
                            )
                          }
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          <div className="text-center">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                setClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Training Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Date of Training</label>

                        <input
                          type="date"
                          value={selectedDate}
                          onChange={(e) => setSelectedDate(e.target.value)}
                          required
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Start Time</label>

                        <input
                          type="time"
                          value={startTime}
                          onChange={(e) => setStartTime(e.target.value)}
                          required
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>End Time </label>

                        <input
                          type="time"
                          value={endTime}
                          onChange={(e) => setEndTime(e.target.value)}
                          required
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Venue </label>

                        <input
                          type="text"
                          value={venue}
                          onChange={(e) => setVenue(e.target.value)}
                          required
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Village Name </label>

                        <input
                          type="text"
                          value={villageName}
                          onChange={(e) => setVillageName(e.target.value)}
                          required
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <label>LGA</label>

                      <input
                        type="text"
                        value={lga}
                        onChange={(e) => setLga(e.target.value)}
                        required
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-6">
                      <label>State</label>
                      <input
                        type="text"
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                        required
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <label>Focused Crop</label>
                      <Select
                        isMulti
                        options={selectionCrop}
                        value={selectedCrop}
                        onChange={(option) => {
                          handleCropChange(option);
                        }}
                        className="basic-multi-select"
                        isRequired={true}
                      />
                    </div>
                    <div className="col-md-6">
                      <label>Executive List</label>
                      <Select
                        isMulti
                        options={selectionUser}
                        value={selectedUser}
                        onChange={(option) => {
                          handleUserChange(option);
                        }}
                        className="basic-multi-select"
                        isRequired={true}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <label>Training Type</label>
                      <select
                        className="form-control"
                        value={trainingType}
                        onChange={(e) => setTrainingType(e.target.value)}
                        required
                      >
                        <option value="">Select</option>
                        <option value="At Hub">At Hub</option>
                        <option value="At Community Level">
                          At Community Level
                        </option>
                      </select>
                    </div>

                    <div className="col-md-6">
                      <label>Topic Of Discussion</label>
                      <input
                        type="text"
                        value={topic}
                        onChange={(e) => setTopic(e.target.value)}
                        required
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <label>Subject List</label> <br />
                      <button
                        className="btn btn-info mx-2 my-2"
                        type="button"
                        onClick={() => setIsSubjectOpen(true)}
                      >
                        Add
                      </button>
                    </div>

                    <div className="col-md-3">
                      <label>Objectives List</label> <br />
                      <button
                        className="btn  btn-success mx-2 my-2"
                        type="button"
                        onClick={() => {
                          setClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>

                    <div className="col-md-3">
                      <label> Trainer Details</label> <br />
                      <button
                        className="btn  btn-warning mx-2 my-2"
                        type="button"
                        onClick={() => {
                          setIsOpen(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-4"
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default SalesTrainingDetailForm;
